import {
    FETCH_STATEMENTS_REQUEST,
    FETCH_STATEMENTS_SUCCESS,
    FETCH_STATEMENTS_FAILURE,
  } from "./FetchStatementsTypes";
  
  const initialState = {
    loading: false,
    statementsList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_STATEMENTS_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_STATEMENTS_SUCCESS:
        return {
          loading: false,
          statementsList: action.payload,
          error: "",
        };
      case FETCH_STATEMENTS_FAILURE:
        return {
          loading: false,
          statementsList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  